import Vue from 'vue';
import Vuetify from 'vuetify';
import colors from './colors';

Vue.use(Vuetify);

const options = {
    icons: {
        iconfont: 'fa',
        values: {
            archive: 'fas fa-trash',
            cancel: 'far fa-times-circle',
            checkboxIndeterminate: 'fas fa-minus-square',
            checkboxOff: 'far fa-square',
            checkboxOn: 'fas fa-check-square',
            clear: 'fas fa-times',
            close: 'fas fa-times',
            company: 'fas fa-building',
            complete: 'fas fa-check',
            delete: 'fas fa-times-circle',
            delimiter: 'fas fa-circle',
            dropdown: 'fas fa-caret-down',
            duplicate: 'far fa-clone',
            edit: 'fas fa-pen',
            error: 'fas fa-exclamation-triangle',
            expand: 'fas fa-angle-down',
            file: 'fas fa-paperclip',
            filter: 'fas fa-filter',
            first: 'fas fa-step-backward',
            grid: 'fas fa-th',
            info: 'fas fa-info-circle',
            last: 'fas fa-step-forward',
            loading: 'fas fa-sync',
            logOut: 'fas fa-sign-out-alt',
            menu: 'fas fa-bars',
            next: 'fas fa-chevron-right',
            notification: 'fas fa-bell',
            plus: 'fas fa-plus',
            prev: 'fas fa-chevron-left',
            radioOff: 'far fa-circle',
            radioOn: 'far fa-dot-circle',
            ratingEmpty: 'far fa-star',
            ratingFull: 'fas fa-star',
            ratingHalf: 'fas fa-star-half',
            search: 'fas fa-search',
            sort: 'fas fa-sort-up',
            subgroup: 'fas fa-caret-down',
            success: 'fas fa-check-circle',
            unfold: 'fas fa-arrows-alt-v',
            user: 'fas fa-user-circle',
            users: 'fas fa-user-friends',
            warning: 'fas fa-exclamation',
        },
    },
    theme: {
        themes: {
            light: {
                primary: '#003b75',
                secondary: '#003b75',
                accent: '#03a9f4',
                error: '#f44336',
                warning: '#ffc107',
                info: '#00bcd4',
                success: '#4caf50',
            },
            dark: {
                primary: '#003b75',
                secondary: '#003b75',
                accent: '#03a9f4',
                error: '#f44336',
                warning: '#ffc107',
                info: '#00bcd4',
                success: '#4caf50',
            },
        },
    },
};

export default new Vuetify(options);
